<section
  class="twofa"
  [class.twofa--info]="step === 'informativo'"
  [class.twofa--code]="step === 'codigo'">

  @if (step === 'informativo') {
    <div class="twofa-info">
      <div class="twofa-info__icon">
        <mat-icon>{{ iconoPrincipal }}</mat-icon>
        <span class="twofa-info__badge">
          <mat-icon>{{ esCorreo ? 'send' : 'sms' }}</mat-icon>
        </span>
      </div>
      <h2>{{ tituloInformativo }}</h2>
      <p class="twofa-info__greeting">
        Estimado usuario,
      </p>
      <p class="twofa-info__message">
        {{ mensajeInformativo }}
      </p>
      @if (procesando) {
        <p class="twofa-info__processing">
          Enviando código...
        </p>
      }
      @if (codigoError) {
        <p class="twofa-info__error">
          {{ codigoError }}
        </p>
      }
      <button
        type="button"
        class="twofa__button twofa__button--primary twofa-info__button"
        [disabled]="procesando || (!codigoSolicitado && !codigoError)"
        (click)="aceptarInformativo()">
        {{ codigoError && !codigoSolicitado ? 'Cerrar' : 'Entendido' }}
      </button>
    </div>
  } @else {
    <header class="twofa-code__bar">
      <h2>{{ tituloModal }}</h2>
    </header>
    <div class="twofa-code">
      <div class="twofa-code__content">
        <div class="twofa-code__illustration">
          <mat-icon>{{ iconoPrincipal }}</mat-icon>
          <span>
            <mat-icon>{{ iconoBadge }}</mat-icon>
          </span>
        </div>
        <div class="twofa-code__main">
          <h3>Ingresa el código</h3>
          <p class="twofa-code__description">
            Hemos enviado un código de 6 dígitos a:
          </p>
          <strong class="twofa-code__destination">
            {{ destinoMostrado }}
          </strong>
          <div
            class="twofa-code__inputs"
            [class.twofa-code__inputs--error]="codigoError"
            [class.twofa-code__inputs--disabled]="bloqueoCodigo || procesando"
            (click)="enfocarCodigo()">
            <input
              #codigoRealInput
              class="twofa-code__real-input"
              type="text"
              inputmode="numeric"
              maxlength="6"
              autocomplete="one-time-code"
              [value]="codigoPlano"
              [disabled]="bloqueoCodigo || procesando"
              (focus)="codigoEnfocado = true"
              (blur)="codigoEnfocado = false"
              (click)="posicionarCursorCodigo()"
              (keydown)="manejarTeclaCodigo($event)"
              (input)="capturarCodigo($event)"
              (paste)="pegarCodigo($event)">
              @for (digito of codigo; track $index; let i = $index) {
                <span
                  class="twofa-code__digit"
                  [class.twofa-code__digit--active]="codigoEnfocado && i === codigoActivoIndex && !bloqueoCodigo && !procesando"
                  [class.twofa-code__digit--filled]="digito">
                  {{ digito }}
                </span>
              }
            </div>
            @if (codigoError) {
              <p class="twofa-code__error">
                {{ codigoError }}
              </p>
            }
            @if (reenvio && !bloqueoCodigo) {
              <p class="twofa-code__resend">
                ¿No recibiste el código?
                <span>Reenviar en {{ formatTime(intervalo) }}</span>
              </p>
            }
            @if (!reenvio || bloqueoCodigo) {
              <button
                type="button"
                class="twofa-code__resend-button"
                [disabled]="procesando"
                (click)="resendCode()">
                Solicitar nuevo código
              </button>
            }
            @if (procesando) {
              <p class="twofa-code__processing">
                <mat-icon>sync</mat-icon>
                Procesando...
              </p>
            }
            <footer class="twofa-code__actions">
              <button
                type="button"
                class="twofa__button twofa__button--secondary"
                [disabled]="procesando"
                (click)="closeDialog('Proceso Cancelado')">
                Cancelar
              </button>
              <button
                type="button"
                class="twofa__button twofa__button--primary"
                [disabled]="formTwoFactorCode.invalid || procesando || bloqueoCodigo"
                (click)="ValidarCodigoTwoFactorCode()">
                Validar código
              </button>
            </footer>
          </div>
        </div>
      </div>
    }

  </section>